import { useEffect, useState } from 'react';

const SCRIPT_URL = 'https://player.vdocipher.com/v2/api.js';
export const API_TIMEOUT_MS = 15000;
let apiRequest;

const apiIsReady = () => typeof window.VdoPlayer?.getInstance === 'function';

// Share one API script between renders and video pages. Failed loads may be retried.
export function loadPlayerApi() {
  if (apiIsReady()) return Promise.resolve();
  if (apiRequest) return apiRequest;
  apiRequest = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    let timeout;
    const finish = (error) => {
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      if (error) {
        script.remove();
        reject(error);
      } else {
        resolve();
      }
    };
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => finish(apiIsReady() ? null : new Error('播放器元件未能初始化，請重試。'));
    script.onerror = () => finish(new Error('播放器元件載入失敗，請檢查網路後重試。'));
    timeout = setTimeout(() => finish(new Error('播放器元件載入逾時，請檢查網路後重試。')), API_TIMEOUT_MS);
    document.body.append(script);
  }).catch(error => {
    apiRequest = null;
    throw error;
  });
  return apiRequest;
}

function loadVideo({ otp, playbackInfo, container, configuration = {} }) {
  const params = new URLSearchParams({ otp, playbackInfo, ...configuration });
  const iframe = document.createElement('iframe');
  iframe.title = '課程影片播放器';
  iframe.setAttribute('allowfullscreen', 'true');
  iframe.setAttribute('allow', 'autoplay; encrypted-media');
  iframe.setAttribute('frameborder', '0');
  iframe.src = 'https://player.vdocipher.com/v2/?' + params;
  container.append(iframe);
  return iframe;
}

export default function useVdoPlayer(retryAttempt = 0) {
  const [state, setState] = useState({ isAPIReady: false, apiError: null });
  useEffect(() => {
    let active = true;
    setState({ isAPIReady: apiIsReady(), apiError: null });
    loadPlayerApi().then(
      () => { if (active) setState({ isAPIReady: true, apiError: null }); },
      error => { if (active) setState({ isAPIReady: false, apiError: error.message }); }
    );
    return () => { active = false; };
  }, [retryAttempt]);
  return { ...state, loadVideo };
}
